// frontend/src/components/chat/OnlineStatus.jsx
// Online status indicator component

import React from "react";

/**
 * Small dot indicator showing online/offline status
 * Used in conversation list and user list avatars
 */
export const OnlineStatusBadge = ({ isOnline, size = "default" }) => {
  return (
    <span
      className={`online-status-dot ${isOnline ? "online" : "offline"} ${
        size === "large" ? "large" : ""
      }`}
      title={isOnline ? "Online" : "Offline"}
    />
  );
};

/**
 * Text-based online status (e.g., "Online" or "Offline")
 * Used in chat window header
 */
export const OnlineStatusText = ({ isOnline }) => {
  return (
    <span className={`online-status-text ${isOnline ? "online" : "offline"}`}>
      <span className={`status-dot ${isOnline ? "online" : "offline"}`} />
      {isOnline ? "Online" : "Offline"}
    </span>
  );
};

export default OnlineStatusBadge;
